import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { ICreateAddressType } from "./interfaces/create-address-type.interface";
import { IUpdateAddressType } from "./interfaces/update-address-type.interface";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import AddressTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/masters/address-type/address-type.entity";

const apiUrl = env.API_COMMON_URL;
const moduleName = "address_type";

@Injectable({
  providedIn: "root",
})
export class AddressTypeService extends AbstractService<
  AddressTypeAttributes,
  ICreateAddressType,
  IUpdateAddressType
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<AddressTypeAttributes> & { companyId?: string; status?: number[] }
  ): Observable<IPaginationResult<AddressTypeAttributes>> {
    const query = buildQuery<AddressTypeAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("type", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      andAllWhere("company.id" as keyof AddressTypeAttributes, Ops.eq(options.companyId ?? "")),
      andAllWhere("statusId", Ops.in(...options?.status ?? [])),
      orderBy(
        options.sort ?? "type",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<AddressTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<AddressTypeAttributes[]>> {
    const query = buildQuery<AddressTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["type", "name","isDelivery"]),
      orderBy("type", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<AddressTypeAttributes[]>>(API_URL);
  }
}
